export const data=[
    {
      "title": "Everything",
      "justIn": "3",
      "stats": {
        "7 days": "16",
        "30 days": "54",
        "90 days": "135"
      },
      "total": "3,660"
    },
    {
      "title": "API Scans",
      "justIn": "1",
      "stats": {
        "7 days": "30",
        "30 days": "123",
        "90 days": "300"
      },
      "total": "5,000"
    },
    {
      "title": "Security Events",
      "justIn": "1",
      "stats": {
        "7 days": "12",
        "30 days": "45",
        "90 days": "100"
      },
      "total": "2,000"
    },
    {
      "title": "Malware Detected",
      "justIn": "1",
      "stats": {
        "7 days": "8",
        "30 days": "23",
        "90 days": "65"
      },
      "total": "450"
    }
  ]